/**
 * App 根组件 — 装配 TanStack QueryClient + Router + 全局 Toast 宿主
 *
 * 全局态走 Zustand 三件套（auth-store / app-scope-store / theme-store）；
 * 业务态走 TanStack Query；toast 通知由根部挂载一次的 <ToastHost/> 渲染。
 * <StuckWriteNotice/> 同样只在根部挂一次：它要覆盖全部写请求，逐页挂会漏（#356）
 */

import { QueryClientProvider } from '@tanstack/react-query';
import { StuckWriteNotice } from '~/app/StuckWriteNotice';
import { queryClient } from '~/lib/query-client';
import { AppRouter } from '~/router/index';
import { ToastHost } from '~/ui/Toast';

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppRouter />
      <ToastHost />
      <StuckWriteNotice />
    </QueryClientProvider>
  );
}
